module.exports = __webpack_public_path__ + "static/media/getReadyForExam_img.8dd97ce8.png";